module.exports = __webpack_public_path__ + "static/media/majorD3.2db25d3.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/sing/majorD3.wav
// module id = l7/M
// module chunks = 0